import axios from "axios";
import employees from "../../models/gestionEmpleados/empleados/employees";
import employedWithPhoto from "../../models/gestionEmpleados/empleados/employedWithPhoto";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
    //Variables suprema
    this.idDevice = null;
    this.template0 = null;
    this.template1 = null;
    this.arrayTemplates = [];
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getEmployees(photo, { limit, offset, where, order, soloActivos } = {}) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const operId = localStorage.getItem("operId");
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const params = {
      incluyeFoto: photo === false ? false : true,
      ...(limit !== undefined && { limit }),
      ...(offset !== undefined && { offset }),
      ...(where && { where: JSON.stringify(where) }),
      ...(order && { order }),
      ...(soloActivos !== undefined && { soloActivos }),
    };

    return axios
      .get(`${url}/empleados/todos/${operId}`, { headers, params })
      .then(({ data }) => {
        return {
          items: data.items.map((item) => employees.fromJson(item)),
          total: data.total,
        };
      })
      .catch((error) => {
        console.error("Error al obtener los empleados:", error);
        throw error;
      });
  }

  getMontlyTab(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/fichamensual/${data.empId}&${data.fecDesde}`, { headers })
      .then(({ data }) => {
        return data;
      });
  }

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const empId = localStorage.getItem("empId");

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    // Crear una copia de `data` y modificar el campo
    const formattedData = { ...data };

    if (formattedData.nombres) {
      formattedData.nombre = formattedData.nombres; // Renombrar el campo
      delete formattedData.nombres; // Eliminar `nombres`
    }

    return axios
      .patch(`${url}/empleados/${empId}`, formattedData, { headers })
      .then(() => {});
  }

  addEmployed(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const operId = parseInt(localStorage.getItem("operId"), 10);
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      operId: operId,
      legajo: data.file,
      tdoc: data.typeDoc,
      ndoc: data.doc,
      apellido: data.lastName,
      nombre: data.name,
      fecAlta: data.high + "T00:00:00.000Z",
      grupoId: data.grupoId,
      horarioId: data.horarioId,
      liqModeloId: data.liqModeloId,
      tarjetaId: data.tarjetaId,
      relojId: data.relojId,
    };
    if (data.photo) {
      payload.vistaPrevia = data.photo;
    }
    if (data.down) {
      payload.fecBaja = data.down + "T00:00:00.000Z";
    }

    return axios.post(`${url}/empleados`, payload, { headers });
  }

  getPhoto() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const empId = localStorage.getItem("empId");
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/empleados/foto/${empId}`, { headers })
      .then(({ data }) => {
        return employedWithPhoto.fromJson(data);
      });
  }

  enabledEmployed(empId) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.patch(`${url}/empleados/habilitar/${empId}`, {}, { headers });
  }

  disabledEmployed(empId) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.patch(
      `${url}/empleados/deshabilitar/${empId}`,
      {},
      { headers }
    );
  }

  getUsersSuprema() {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.get(`${url}/biostar/users`, { headers }).then((response) => {
      const users = response.data.UserCollection.rows.map((user) => ({
        id: user.user_id,
      }));
      return users;
    });
  }

  /*
  ------[SE COMENTA PORQUE SE ASUME QUE SI USUARIO NO EXISTE EN SUPREMA NO SE VA A CREAR EN DS9]------
   newUser(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {
      User: data,
    };
    return axios
      .post(`${url}/biostar/users`, payload, { headers })
      .then((response) => response.data);
  }
 */

  getDevices() {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.get(`${url}/biostar/devices`, { headers }).then((response) => {
      const devices = response.data.DeviceCollection.rows.map((device) => ({
        id: device.id,
        name: device.name,
      }));
      return devices;
    });
  }

  // Servicio (sin callbacks, cada método devuelve su resultado)
  async scanFingerPrint(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    this.idDevice = data.idDevice;
    const payload = {
      enroll_quality: data.enrollQuality,
      raw_image: data.rawImage,
    };

    const response = await axios.post(
      `${url}/biostar/devices/${this.idDevice}/scan_fingerprint`,
      payload,
      { headers }
    );
    return response.data.FingerprintTemplate;
  }

  async identifyFingerPrint(template0) {
    try {
      const token = localStorage.getItem("token");
      const url = this.config.apiUrl;
      let headers = {
        Authorization: `Bearer ${token}`,
      };
      const payload = { ServerMatching: { template: template0 } };
      const response = await axios.post(
        `${url}/biostar/identify_finger`,
        payload,
        { headers }
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 500) {
        return false;
      }
      throw error;
    }
  }

  async verifyFingerprint(template0, template1) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {
      FingerprintTemplate: {
        template0,
        template1,
      },
      VerifyFingerprintOption: {
        security_level: "0",
      },
    };

    const response = await axios
      .post(`${url}/biostar/verify_fingerprint/${this.idDevice}`, payload, {
        headers,
      })
      .then(() => {
        this.arrayTemplates.push({
          finger_mask: "false",
          template0,
          template1,
          isNew: true,
        });
      });
    return response;
  }

  editFingerprintToUser(id, arrayModified) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let formatted = [];
    let payload = {};

    if (this.arrayTemplates?.length > 0) {
      formatted = this.arrayTemplates.map((t) => ({
        finger_mask: "false",
        template0: t.template0,
        template1: t.template1,
      }));
    }

    if (Array.isArray(arrayModified)) {
      if (arrayModified?.length > 0) {
        // Pisa el array de huellas, funciona como un "delete"
        arrayModified = arrayModified.map((t) => ({
          finger_mask: "false",
          template0: t.template0,
          template1: t.template1,
        }));

        payload = {
          User: {
            fingerprint_templates: arrayModified,
          },
        };
      } else {
        payload = {
          User: {
            fingerprint_templates: [],
          },
        };
      }
    } else {
      // Agraga el array de huellas formateado, funciona como un "add"
      payload = {
        User: {
          fingerprint_templates: formatted,
        },
      };
    }
    return axios.post(
      `${url}/biostar/assign_fingerprint_to_user/${id}`,
      payload,
      { headers }
    );
  }

  getInfoUser(idUser) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/biostar/users/${idUser}`, { headers })
      .then((response) => {
        this.arrayTemplates = response.data.User.fingerprint_templates
          ? response.data.User.fingerprint_templates
          : [];

        return response.data.User;
      })
      .catch((error) => {
        return null;
      });
  }
}
export default service;
